import React from "react";
import MegaHeader from "../components/MegaHeader/MegaHeader";
import Footer from "../components/footer/Footer";
import BlogSection from "../components/blogs-section/BlogSection";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import SoftwareCompanyCta from "../components/software-company-cta/SoftwareCompanyCta";
import MegaMenu from "../components/MegaMenu/MegaMenu";

const Blogs = () => {
  const { t: tmetaTitles } = useTranslation("metaTitles");
  const metaTitle = tmetaTitles("blogsTitle", { returnObjects: false });

  const { t: tfooter } = useTranslation("footer");
  const footerCtaContent = tfooter("footerCtaContent", {
    returnObjects: true,
  });
  return (
    <>
      <Helmet>
        <title>{metaTitle}</title>
        <meta
          name="description"
          content="Explore the latest insights, trends, & expert perspectives in software development, IT solutions, & tech innovation with Bitsclan’s blog."
        />
      </Helmet>
      <MegaMenu />
      <BlogSection />
      <SoftwareCompanyCta content={footerCtaContent} />
      <Footer />
    </>
  );
};

export default Blogs;
